import { AGENT_ID_COOKIE_NAME } from 'src/services/analytics/analytics';
import { readCookie } from 'src/utils/Cookies';
import { GrowthLeadRequest } from '../../services/shop/checkout';
import { CartDetailModel, CheckoutModel } from '../Cart/models';
import { Installments } from '../OrderSummary/types';
import { CheckoutInfoFields } from './CheckoutInfoPage/CheckoutInfoPage';

const SUBMIT_CART_ACTIVITY_TYPE = 'formSubmit_c';
const SUBMIT_CART_SALESFORCE_ID = '00G0g000004YKy4';

export type SubmitCartType = {
  cart: CartDetailModel;
  checkout: CheckoutModel;
  userInfo: CheckoutInfoFields;
  emailAddress: string;
  resellerId: string;
  marketingInfo: { [key: string]: any };
  selectedPurchaseType: Installments;
};

export const generateCartRequestObject = ({ cart, checkout, userInfo, emailAddress, resellerId, marketingInfo, selectedPurchaseType }: SubmitCartType) => {
  if (!userInfo) throw new Error('Cannot submit cart. Missing: User Information');
  if (!emailAddress) throw new Error('Cannot submit cart. Missing: User Email');
  if (!cart.softwarePlan) throw new Error('Cannot submit cart. Missing: Software Plan');
  if (!resellerId) throw new Error('Cannot submit cart. Missing: Reseller UUID');

  const chainAgentId = readCookie(AGENT_ID_COOKIE_NAME);
  if (!chainAgentId) throw new Error('Cannot submit cart. Missing: Chain Agent ID');

  const salesforceOwnerId = SUBMIT_CART_SALESFORCE_ID;
  const bundleId = cart.bundle?.id;

  const requestObject: GrowthLeadRequest = {
    email: emailAddress,
    firstName: userInfo.firstName,
    lastName: userInfo.lastName,
    businessName: userInfo.businessName,
    marketingInfo,
    chainAgentId,
    activityType: SUBMIT_CART_ACTIVITY_TYPE,
    resellerUuid: resellerId,
    salesforceOwnerId,
    order: {
      planId: cart.softwarePlan.id,
      shippingAddress: {
        city: userInfo.city,
        lineOne: userInfo.address1,
        lineTwo: userInfo.address2,
        state: userInfo.state,
        zipCode: userInfo.zip,
      },
      items: [],
    },
  };

  if (checkout.promo.applied) requestObject.order!.promoCode = checkout.promo.applied;
  if (bundleId) requestObject.order!.bundleId = bundleId;

  cart.bundle?.hardware.forEach(product => {
    requestObject.order!.items.push({
      fdmpId: product.fdmpId,
      digitalCatalogId: product.id,
      purchaseType: selectedPurchaseType,
      quantity: product.quantity,
    });
  });

  cart.products.forEach(product => {
    requestObject.order!.items.push({
      fdmpId: product.fdmpId,
      digitalCatalogId: product.id,
      purchaseType: selectedPurchaseType,
      quantity: product.quantity,
    });
  });

  return requestObject;
};
